export const OfferUat = {
  container: 'offerView.offer.container',
  selected: 'offerView.offer.container.selected'
}
